module.exports = __webpack_public_path__ + "static/media/virus.242a8f63.png";